import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import VendorQualificationTable from "./VendorQualificationTable";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import TenderEMDTable from "./TenderEMDTable";
import TenderPurchaseTable from "./TenderPurchaseTable";

const VendorQualificationTab = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const { tenderId } = useParams();
  const [vq, setVq] = useState();
  const [emd, setEmd] = useState();
  const [activeTab, setActiveTab] = useState(storedUser.userRole[0] === "FINANCE_HEAD" || storedUser.userRole[0] === "SUPERADMIN" ? localStorage.getItem("tab") : "PENDING");
  const [tab, setTab] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const getVendorTenders = async (page) => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/get-by-id?username=${storedUser.username}&tenderId=${tenderId}&status=${activeTab}&page=${page || 0}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsLoading(false);
      localStorage.removeItem("tab");
    } catch (error) {
      console.log(error);
    }
  };

  const getTenderEMD = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-emd/get-by-tender?tenderId=${tenderId}&status=${activeTab}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setEmd(res.data);
      setIsLoading(false);
      localStorage.removeItem("tab");
    } catch (error) {
      console.log(error);
    }
  };

  const getTenderPurchase = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-purchase/get-by-tender?tenderId=${tenderId}&status=${activeTab}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setEmd(res.data);
      setIsLoading(false);
      localStorage.removeItem("tab");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "EMD" || activeTab === "EMD_CMD_ACCEPTED") {
      getTenderEMD();
    } else if (activeTab === "PURCHASE" || activeTab === "PURCHASE_ACCEPTED") {
      getTenderPurchase();
    } else {
      getVendorTenders();
    }
  }, [activeTab]);

  const handlePendingBtn = () => {
    localStorage.setItem("pending", JSON.stringify("VQ"));
    navigate("/dashboard");
  };

  const tabButtons =
    storedUser.userRole[0] === "BUYER"
      ? [
          { label: "Pending", value: "PENDING", tab: 1 },
          { label: "Approved", value: "QSTAGE_1", tab: 2 },
          { label: "Rejected", value: "DISQUALIFIED", tab: 2 },
          { label: "Review Later", value: "REVIEW_LATER", tab: 1 },
        ]
      : storedUser.userRole[0] === "TECHNICAL_HEAD"
      ? [
          { label: "Pending", value: "PENDING", tab: 1 },
          { label: "Approved", value: "QSTAGE_2", tab: 2 },
          { label: "Rejected", value: "DISQUALIFIED", tab: 2 },
          { label: "Review Later", value: "REVIEW_LATER", tab: 1 },
        ]
      : storedUser.userRole[0] === "FINANCE_HEAD" && (activeTab === "EMD" || activeTab === "EMD_CMD_ACCEPTED")
      ? [
          { label: "EMD Details", value: "EMD", tab: 1 },
          { label: "EMD Verified", value: "EMD_CMD_ACCEPTED", tab: 2 },
        ]
        : (storedUser.userRole[0] === "FINANCE_HEAD" || storedUser.userRole[0] === "SUPERADMIN") && (activeTab === "PURCHASE" || activeTab === "PURCHASE_ACCEPTED")
      ? [
          { label: "Purchase Details", value: "PURCHASE", tab: 1 },
          { label: "Purchase Verified", value: "PURCHASE_ACCEPTED", tab: 2 },
        ]
      : [
          { label: "Pending", value: "PENDING", tab: 1 },
          { label: "Approved", value: "QUALIFIED", tab: 2 },
          { label: "Rejected", value: "DISQUALIFIED", tab: 2 },
          { label: "Review Later", value: "REVIEW_LATER", tab: 1 },
        ];

  return (
    <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          borderBottom: "1px solid #D1D1D1",
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          {tabButtons.map((btn) => (
            <Button
              key={btn.value}
              className={`dashboard-btns ${
                activeTab === btn.value ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab(btn.value);
                setTab(btn.tab);
                setIsLoading(true);
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>

        {storedUser.userRole[0] === "BUYER" && (
          <Box>
            <Button className="pending-btn" onClick={handlePendingBtn}>
              My Pending actions
            </Button>
          </Box>
        )}
      </Box>

      {activeTab === "EMD" || activeTab === "EMD_CMD_ACCEPTED" ? (
        <TenderEMDTable
          vendors={emd}
          isLoading={isLoading}
          getTenderEMD={getTenderEMD}
          tab={tab}
        />
      ) : activeTab === "PURCHASE" || activeTab === "PURCHASE_ACCEPTED" ? (
        <TenderPurchaseTable
          vendors={emd}
          isLoading={isLoading}
          getTenderPurchase={getTenderPurchase}
          tab={tab}
        />
      ) : (
        <VendorQualificationTable
          vendors={vq}
          isLoading={isLoading}
          getVendorTenders={getVendorTenders}
          tab={tab}
        />
      )}
    </Box>
  );
};

export default VendorQualificationTab;
